import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ProfileInformationPage = lazy(() => import("./ProfileInformationPage"));

const ProfileInformationPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ProfileInformationPage />
    </Suspense>
  );
};

export default ProfileInformationPageLazy;
